<template>
    <v-container>
        <v-btn
            fab
            :loading="isloading"
            :disabled="isloading"
            color="orange darken-1"
            class="mt-2"
            @click="openNew"
        >
            <v-icon class="white--text">mdi-account-plus-outline</v-icon>
        </v-btn>
        <v-data-table
            dense
            :headers="headers"
            :items="items"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.action="{ item }">
                <v-icon
                    @click="openEdit(item)"
                    small
                    class="mr-2"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="EDITAR"
                    >mdi-pencil-outline</v-icon
                >

                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>
        <v-dialog v-model="dialog_save" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar objetivo
                </v-card-title>
                <v-card-text style="text-align: center">
                    <form ref="form_km">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    type="number"
                                    label="Año"
                                    v-model="objetivo.year"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    type="number"
                                    label="Objetivo"
                                    v-model="objetivo.objetivo"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </form>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog_save = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="save()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
export default {
    props: ["items", "id_comercial"],
    data() {
        return {
            objetivo: {},
            dialog_save: false,
            headers: [
                {
                    text: "Año",
                    align: "left",
                    value: "year",
                },
                {
                    text: "Objetivo",
                    align: "left",
                    value: "objetivo",
                },
            ],
        };
    },
    methods: {
        openNew() {
            this.objetivo = {};
            this.dialog_save = true;
        },
        openEdit(item) {
            this.objetivo = item;

            this.dialog_save = true;
        },
        save() {
            if (this.id_comercial) {
                this.objetivo.id_comercial = this.id_comercial;
            }
            axios
                .post("api/save-objetivos-ventas", this.objetivo)
                .then((res) => {
                    this.$emit("save", res.data);

                    this.dialog_save = false;
                })
                .catch((error) => {
                    this.$custom_error(error.response.data);
                });
        },
    },
};
</script>
